import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  "stroke-width": "15",
  viewBox: "-50 -50 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><linearGradient id=\"gradient\" x1=\"0%\" x2=\"0%\" y1=\"30%\" y2=\"100%\"><stop offset=\"0%\" stop-color=\"#009DD8\"></stop><stop offset=\"50%\" stop-color=\"#0566A8\"></stop><stop offset=\"100%\" stop-color=\"#0A2D73\"></stop></linearGradient></defs><circle r=\"45\"></circle><circle r=\"45\" stroke-dasharray=\"282.743\" stroke-dashoffset=\"226.195\" stroke=\"url(#gradient)\"></circle>", 3)
  ]))]))
}
export default { render: render }